// libraries.
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// slices.
import { DocumentsTool } from '../../../../DocumentsVisualizer/interfaces/sideBar.types';
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// components.
import { ButtonSidebar } from '@shared';

// assets.
import { IconDocument } from '@assets/icons';

export const ButtonDocumentsTasks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectSidebarButton(DocumentsTool.tasks));
    navigate('/document-audit/tasks');
  };

  return (
    <ButtonSidebar icon={<IconDocument fill="white" />} text="Tareas" onClick={handleClick} />
  );
};
